module.exports = __webpack_public_path__ + "img/icon-reisegepaeck.0e432efb.svg";